import { colors, spacing, radius, shadows, typography } from '../tokens';
export const cardStyles = {
    base: {
        backgroundColor: colors.white,
        borderRadius: radius.lg,
        border: `1px solid ${colors.gray[200]}`,
        padding: spacing[4],
        fontFamily: typography.fontFamily.sans,
    },
    elevated: {
        backgroundColor: colors.white,
        borderRadius: radius.lg,
        boxShadow: shadows.md,
        padding: spacing[4], // Reduced from spacing[5] for less wasted space
        fontFamily: typography.fontFamily.sans,
    },
};
//# sourceMappingURL=card.js.map